"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../");
var DurationDtoFactory = /** @class */ (function () {
    function DurationDtoFactory() {
    }
    DurationDtoFactory.fromOfferingDto = function (offeringDto) {
        return {
            startDate: offeringDto.schedule.startDate,
            durationInMinutes: DurationDtoFactory.durationInMinutesFromOffering(offeringDto),
        };
    };
    DurationDtoFactory.durationInMinutesFromOffering = function (offeringDto) {
        if (offeringDto.type === __1.OfferingType.INDIVIDUAL ||
            offeringDto.type === __1.OfferingType.DUMMY ||
            offeringDto.type === __1.OfferingType.GROUP) {
            var schedule = offeringDto.schedule;
            return schedule.durationInMinutes;
        }
        return 0;
    };
    return DurationDtoFactory;
}());
exports.DurationDtoFactory = DurationDtoFactory;
//# sourceMappingURL=duration-dto-factory.js.map